

(function showPopupDirectiveDefinition() {

    angular.module('Popup')
        .directive('showPopup', ['popup', '$timeout',
            function showPopupDirectiveFactory(popup, $timeout) {

                return {
                    restrict: 'A',
                    scope: {
                        isOpen: '=?',
                        popupPlacement: '&',
                        popupTemplate: '&',
                        popupTitle: '@',
                        showPopup: '&',
                        popupAutoClose: '=?',
                        fillIfOutsideWindow: '=?'
                    },
                    link: function showPopupDirectiveLink($scope, element, attrs) {
                        
                        var pupupElement = '';

                        var options = {
                            contentUrl: $scope.showPopup(),
                            placement: $scope.popupPlacement() || 'bottom-center',
                            template: $scope.popupTemplate() || '<div class="popup popup-content"></div>',
                            title: $scope.popupTitle,
                            autohide: $scope.popupAutoClose || true,
                            scope: $scope.$parent,
                            trigger: (attrs.isOpen ? '' : 'click'),
                            fillIfOutsideWindow: $scope.fillIfOutsideWindow || false
                        };

                        var ctrl = popup.popover(element, options);

                        if (attrs.isOpen) {

                            var internal = false;

                            // cambio los metodos hide y show por unos que toquen la variable isOpen.
                            ctrl.onHide(function () {
                                if ($scope.isOpen) {
                                    $scope.isOpen = false;
                                    internal = true;
                                }
                            });
                            ctrl.onShow(function () {
                                if (!$scope.isOpen) {
                                    $scope.isOpen = true;
                                    internal = true;
                                }
                            });

                            $scope.$watch('isOpen', function togglePopup(value) {
                                if (internal) {
                                    internal = false;
                                    return;
                                }
                                if (value) {
                                    ctrl.show();
                                } else {
                                    ctrl.hide();
                                }
                            });

                            element.on("click", function () {
                                $timeout(function() {
                                    $scope.isOpen = true;
                                });
                                return false;
                            });
                        } 
                    }
                };

            }
        ]);

})();